<template>
  <div>
    <b-modal id="modalIPTVService" ref="modalIPTVService" :title="$t('IPTV service')" hide-footer @shown="shown" size="lg">
      <div v-if="editItem && (serviceType === 8)">
        <b-tabs pills card>
          <b-tab :title="$t('Main')">
            <b-form-group label-align="right" :label="$t('Parent service')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isTariffs || isTariffPlan">
              <b-form-input type="text" disabled v-model="editItem.service_data.parent_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.service_data.service_name" aria-describedby="inputFeedbackName" :state="editItem.service_data.service_name.length > 0"/>
              <b-form-invalid-feedback id="inputFeedbackName">
                {{ $t('Enter title') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.service_data.comment"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Supplier to invoice')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="suppliertList" v-model="editItem.service_data.invoice_sup_id"/>
            </b-form-group>
            <b-form-group v-if="isTemplates || isTariffs || isTariffPlan">
              <b-form-checkbox v-model="editItem.service_data.link_by_default" value=1 unchecked-value=0>{{ $t('Attach by default') }}</b-form-checkbox>
              <b-form-checkbox v-model="editItem.service_data.multiple_linking" value=1 unchecked-value=0>{{ $t('Allow multiple linking') }}</b-form-checkbox>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Service parameters')">
            <b-form-group label-align="right" :label="$t('Cost')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" :disabled="editItem.service_data.links_count !== 0" v-model="editItem.periodic_service_data.cost" aria-describedby="inputFeedbackCost" :state="editItem.periodic_service_data.cost !== ''"/>
              <b-form-invalid-feedback id="inputFeedbackCost">
                {{ $t('Enter cost') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charge method')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="chargeMethodList" v-model="editItem.periodic_service_data.charge_method"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="policyList" v-model="editItem.periodic_service_data.policy_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Scheme for schedule')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="schemeList" v-model="editItem.periodic_service_data.scheme_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Contract type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="contractList" v-model="editItem.service_data.contract_type"/>
            </b-form-group>

            <b-form-group label-align="right" :label="$t('IPTV system type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="typeIPTVList" v-model="selectIPTV"/>
            </b-form-group>
            <b-form-group v-if="![0,1,6,7].includes(selectIPTV)" label-align="right" :label="$t('Custom options')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.iptv_service_data.custom_data"/>
            </b-form-group>
            <b-form-group v-if="selectIPTV == 6" label-align="right" :label="$t('Is basic')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox switch size="lg" v-model="editItem.iptv_service_data.custom_data" value="1" unchecked-value="0" />
            </b-form-group>
            <b-form-group v-if="selectIPTV == 0" label-align="right" label="CatchUP" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="iptvCatchUP" v-model="editItem.iptv_service_data.custom_data"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="selectIPTV === 0">
              <b-form-select :options="typeNetupList" v-model="selectNetup"/>
            </b-form-group>
            <b-form-group v-if="selectIPTV == 6" label-align="right" :label="$t('Tariff')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="tv24Tariffs" v-model="editItem.iptv_service_data.media_group"/>
            </b-form-group>
            <b-form-group v-if="selectIPTV == 7" label-align="right" :label="$t('Tariff')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model.number="editItem.iptv_service_data.media_group"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Media content')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="selectIPTV === 0">
              <b-row>
                <b-col cols="10">
                  <b-form-select :options="filtredMediaContents" v-model="selectMediaContent" :disabled="selectMedia === '2'"/>
                </b-col>
                <b-col>
                  <b-form-radio v-model="selectMedia" value="1"></b-form-radio>
                </b-col>
              </b-row>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Media group')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="selectIPTV === 0">
              <b-row>
                <b-col cols="10">
                  <b-form-select :options="filtredMediaGroups" v-model="selectMediaGroup" :disabled="selectMedia === '1'"/>
                </b-col>
                <b-col>
                  <b-form-radio v-model="selectMedia" value="2"></b-form-radio>
                </b-col>
              </b-row>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Service ID')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="selectIPTV === 1">
              <b-form-input type="nymber" v-model="serviceId"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Test period')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="selectIPTV === 1">
              <b-form-input type="nymber" v-model="delay"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Additional packet')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="selectIPTV === 1">
              <b-form-checkbox v-model="additional"/>
            </b-form-group>
          </b-tab>
        </b-tabs>

        <modal-ok-cancel @save="saveIPTVService" @cancel="$refs.modalIPTVService.hide" size="lg"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    schemeList: null,
    serviceType: null,
    policyList: null,
    suppliertList: null,
    contractList: null,
    isTariffs: null,
    isTemplates: null,
    isEdit: null,
    isTariffPlan: null,
    editItem: null,
    currentRowTariffPlans: null
  },
  data () {
    return {
      additional: false,
      serviceId: 0,
      delay: 0,
      chargeMethodList: [
        {text: this.$i18n.t('At the start of the period'), value: 1},
        {text: this.$i18n.t('At the end of the period'), value: 2},
        {text: this.$i18n.t('Flow method'), value: 3}
      ],
      selectIPTV: 0,
      typeIPTVList: [
        {text: 'NetUP', value: 0},
        {text: 'Megogo', value: 1},
        {text: 'Lifestream', value: 2},
        {text: this.$i18n.t('Other'), value: 3},
        {text: 'IPTVPortal', value: 4},
        {text: 'IrdetoCAS', value: 5},
        {text: '24TV', value: 6},
        {text: 'Moovi', value: 7}
      ],
      iptvCatchUP: [
        {text: 'Not selected', value: ''},
        {text: 'IPTV', value: '0'},
        {text: 'IPTV+CatchUP', value: '1'},
        {text: 'CatchUP', value: '2'}
      ],
      selectNetup: 'all',
      typeNetupList: [
        {text: this.$i18n.t('All'), value: 'all'},
        {text: this.$i18n.t('TV-channels'), value: 'tv'},
        {text: this.$i18n.t('Radio'), value: 'radio'}
      ],
      selectMediaContent: 0,
      mediaContentList: [],
      selectMediaGroup: 0,
      mediaGroupList: [],
      selectMedia: '2'
    }
  },
  methods: {
    async saveIPTVService () {
      if (!this.editItem.service_data.service_name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (this.selectIPTV === 0) {
        if (this.selectMedia === '1') {
          this.editItem.iptv_service_data.media_content = this.selectMediaContent
        } else if (this.selectMedia === '2') {
          this.editItem.iptv_service_data.media_group = this.selectMediaGroup
        } else {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Media content or media group fields is invalid'), 'Error')
          return
        }
      }

      if (this.isTemplates || this.isTariffs || this.isTariffPlan) {
        if (this.editItem.service_data.parent_id === 0) this.editItem.service_data.parent_id = -1
        this.editItem.service_data.link_by_default = Number(this.editItem.service_data.link_by_default)
        this.editItem.service_data.multiple_linking = Number(this.editItem.service_data.multiple_linking)
      }
      if (this.isTariffPlan) {
        this.editItem.service_data.tariff_id = this.currentRowTariffPlans.id
      }
      if (this.selectIPTV === 1) {
        this.editItem.iptv_service_data.custom_data = 'ServiceId:' + this.serviceId + ',delay:' + this.delay + ',additional:' + this.additional + ',movieId:0'
      }
      this.editItem.periodic_service_data.cost = Number(this.editItem.periodic_service_data.cost)
      this.editItem.iptv_service_data.iptv_type = this.selectIPTV
      this.editItem.iptv_service_data.custom_data = String(this.editItem.iptv_service_data.custom_data)

      let response = this.isEdit
        ? this.$store.dispatch('Tariffing/UPDATE_IPTV_SERVICE', this.editItem)
        : this.$store.dispatch('Tariffing/CREATE_IPTV_SERVICE', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
          this.$refs.modalIPTVService.hide()
          this.$root.$emit('makeToasts')

          let sid = this.isEdit ? this.editItem.service_data.service_id : response.data.service_id

          let invID = this.editItem.service_data.invoice_sup_id ? this.editItem.service_data.invoice_sup_id : 0
          this.$store.dispatch('Tariffing/UPDATE_SUPPLIER_ID', {service_id: sid, invoice_sup_id: invID})

          this.$store.dispatch('Tariffing/UPDATE_CHARGE_POLICY', {service_id: sid, policy_id: this.editItem.periodic_service_data.policy_id})

          if (this.isTemplates || this.isTariffPlan) {
            let ml = this.editItem.service_data.multiple_linking ? this.editItem.service_data.multiple_linking : 0
            this.$store.dispatch('Tariffing/UPDATE_MULTI_LINKING', {service_id: sid, multiple_linking: ml})
          }
        }
      })
    },
    shown () {
      this.$store.dispatch('Settings/GET_TV_24_AVAILABLE_TARIFFS')
      this.additional = false
      this.serviceId = 0
      this.delay = 0
      this.selectIPTV = 0
      this.selectNetup = 'all'
      this.selectMediaContent = 0
      this.selectMediaGroup = 0
      this.selectMedia = '2'
      this.mediaContentList = []
      this.mediaGroupList = []
      if (this.$store.getters['Tariffing/MEDIA_CONTENTS']) {
        for (let el of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/MEDIA_CONTENTS']))) {
          let newEl = {
            value: el.id,
            text: el.name
          }
          this.mediaContentList.push(newEl)
        }
      }
      if (this.$store.getters['Tariffing/MEDIA_GROUPS']) {
        for (let el of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/MEDIA_GROUPS']))) {
          let newEl = {
            value: el.id,
            text: el.name
          }
          this.mediaGroupList.push(newEl)
        }
      }
      if (this.isEdit || this.isTariffPlan) {
        this.selectIPTV = this.editItem.iptv_service_data.type
        if (this.editItem.iptv_service_data.media_group !== 0) {
          this.selectMedia = '2'
        } else {
          this.selectMedia = '1'
        }
        this.selectMediaGroup = this.editItem.iptv_service_data.media_group
        this.selectMediaContent = this.editItem.iptv_service_data.media_content
        if (this.selectIPTV === 1) {
          let str = JSON.parse(JSON.stringify(this.editItem.iptv_service_data.custom_data.split(',')))
          this.serviceId = str[0].split(':')[1]
          this.delay = str[1].split(':')[1]
          this.additional = str[2].split(':')[1]
        }
      }
    }
  },
  computed: {
    filtredMediaGroups () {
      if (this.selectNetup === 'all') {
        return this.mediaGroupList.filter(el => {
          return el.type !== 'vod'
        })
      }
      return this.mediaGroupList.filter(el => {
        return (el.type === this.selectNetup || el.type === 'unknown') && el.type !== 'vod'
      })
    },
    filtredMediaContents () {
      if (this.selectNetup === 'all') {
        return this.mediaContentList.filter(el => {
          return el.type !== 'vod'
        })
      }
      return this.mediaContentList.filter(el => {
        return (el.type === this.selectNetup || el.type === 'unknown') && el.type !== 'vod'
      })
    },
    tv24Tariffs () {
      let tmp = this.$store.getters['Settings/TV_24_AVAILABLE_TARIFFS']
      for (let el of tmp) {
        el.value = el.id
        el.text = (el.base ? this.$t('Base packet') + ': ' : '') + el.name + '(' + el.price + ')'
      }
      return tmp
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formIPTVService.vue